import { render, staticRenderFns } from "./SingleRoom.vue?vue&type=template&id=b565adf4&scoped=true&"
import script from "./SingleRoom.vue?vue&type=script&lang=js&"
export * from "./SingleRoom.vue?vue&type=script&lang=js&"
import style0 from "./SingleRoom.vue?vue&type=style&index=0&id=b565adf4&scoped=true&lang=css&"
import style1 from "./SingleRoom.vue?vue&type=style&index=1&lang=css&"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565adf4",
  null
  
)

export default component.exports